export default "__VITE_ASSET__CzA1Nvnw__"